export const corporateConstants = {
  LOAD: "corporateConstants/LOAD",
  LOAD_SUCCESS: "corporateConstants/LOAD_SUCCESS",
  LOAD_FAIL: "corporateConstants/LOAD_FAIL",
  FLUSH: "corporateConstants/FLUSH",
  FLUSH_ERROR: "corporateConstants/FLUSH_ERROR",
  ALL_CORPORATE_ACCOUNTS: "corporateConstants/ALL_CORPORATE_ACCOUNTS",
  SAVE_CORPORATE_ACCOUNTS: "corporateConstants/SAVE_CORPORATE_ACCOUNTS",
  DELETE_CORPORATE_ACCOUNTS: "corporateConstants/DELETE_CORPORATE_ACCOUNTS",
  GET_INVOICE_LOAD: "corporateConstants/GET_INVOICE_LOAD",
  GET_INVOICE_SUCCESS: "corporateConstants/GET_INVOICE_SUCCESS",
  GET_INVOICE_FAIL: "corporateConstants/GET_INVOICE_FAIL",
  INVOICE_FLUSH: "corporateConstants/INVOICE_FLUSH",
  UPDATE_PRICE_LOAD: "corporateConstants/UPDATE_PRICE_LOAD",
  UPDATE_PRICE_SUCCESS: "corporateConstants/UPDATE_PRICE_SUCCESS",
  UPDATE_PRICE_FAIL: "corporateConstants/UPDATE_PRICE_FAIL",
  GET_VERSIONS_LOAD: "corporateConstants/GET_VERSIONS_LOAD",
  GET_VERSIONS_SUCCESS: "corporateConstants/GET_VERSIONS_SUCCESS",
  GET_VERSIONS_FAIL: "corporateConstants/GET_VERSIONS_FAIL",
  UPDATE_VERSION_LOAD: "corporateConstants/UPDATE_VERSION_LOAD",
  UPDATE_VERSION_SUCCESS: "corporateConstants/UPDATE_VERSION_SUCCESS",
  UPDATE_VERSION_FAIL: "corporateConstants/UPDATE_VERSION_FAIL",
  FLUSH_MESSAGE: "corporateConstants/FLUSH_MESSAGE",
  GET_PAYMENT_LIST_LOAD: "corporateConstants/GET_PAYMENT_LIST_LOAD",
  GET_PAYMENT_LIST_SUCCESS: "corporateConstants/GET_PAYMENT_LIST_SUCCESS",
  GET_PAYMENT_LIST_FAIL: "corporateConstants/GET_PAYMENT_LIST_FAIL",
  GET_CONTACT_LOAD: "corporateConstants/GET_CONTACT_LOAD",
  GET_CONTACT_SUCCESS: "corporateConstants/GET_CONTACT_SUCCESS",
  GET_CONTACT_FAIL: "corporateConstants/GET_CONTACT_FAIL",
  FLUSH_CONTACT: "corporateConstants/FLUSH_CONTACT",
  UPDATE_CONTACT_LOAD: "corporateConstants/UPDATE_CONTACT_LOAD",
  UPDATE_CONTACT_SUCCESS: "corporateConstants/UPDATE_CONTACT_SUCCESS",
  UPDATE_CONTACT_FAIL: "corporateConstants/UPDATE_CONTACT_FAIL",
  ADD_CONTACT_LOAD: "corporateConstants/ADD_CONTACT_LOAD",
  ADD_CONTACT_SUCCESS: "corporateConstants/ADD_CONTACT_SUCCESS",
  ADD_CONTACT_FAIL: "corporateConstants/ADD_CONTACT_FAIL",
  DELETE_CONTACT_LOAD: "corporateConstants/DELETE_CONTACT_LOAD",
  DELETE_CONTACT_SUCCESS: "corporateConstants/DELETE_CONTACT_SUCCESS",
  DELETE_CONTACT_FAIL: "corporateConstants/DELETE_CONTACT_FAIL",
  ENABLE_CONTACT_LOAD: "corporateConstants/ENABLE_CONTACT_LOAD",
  ENABLE_CONTACT_SUCCESS: "corporateConstants/ENABLE_CONTACT_SUCCESS",
  ENABLE_CONTACT_FAIL: "corporateConstants/ENABLE_CONTACT_FAIL",
};
